import { ICorporatePartner } from './corporate-partner.interface';
import { DefaultDisplay } from './default.class';
import { EdpPartner } from './edp.class';
import { HipmunkPartner } from './hipmunk.class';
import { Kayak4Business } from './kyaka-for-business.class';
import {
  NuTravelNoProgramPartner,
  NuTravelSmePartner,
  NuTravelSmeSkybPartner,
  NuTravelSpidPartner
} from './nutravel-partner.class';
import { PersonalPartner } from './personal.class';
import {
  StandaloneOaSmePartner,
  StandaloneSkySmePartner,
  StandaloneSmePartner
} from './standalone-sme-partner.class';
import { ConcurNoSpidPartner, ConcurSpidPartner } from './triplink.class';

export const corporatePartners: Array<ICorporatePartner> = [
  new DefaultDisplay(),
  new PersonalPartner(),
  new EdpPartner(),
  new ConcurSpidPartner(),
  new ConcurNoSpidPartner(),
  new HipmunkPartner(),
  new NuTravelSpidPartner(),
  new NuTravelSmePartner(),
  new NuTravelSmeSkybPartner(),
  new NuTravelNoProgramPartner(),
  new StandaloneSmePartner(),
  new StandaloneOaSmePartner(),
  new StandaloneSkySmePartner(),
  new Kayak4Business()
];
